/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Candidate_Profile_Upload_ResumeInputs */

const en_candidate_profile_upload_resume = /** @type {(inputs: Candidate_Profile_Upload_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload resume`)
};

const de_candidate_profile_upload_resume = /** @type {(inputs: Candidate_Profile_Upload_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lebenslauf hochladen`)
};

/**
* | output |
* | --- |
* | "Upload resume" |
*
* @param {Candidate_Profile_Upload_ResumeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const candidate_profile_upload_resume = /** @type {((inputs?: Candidate_Profile_Upload_ResumeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Candidate_Profile_Upload_ResumeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_candidate_profile_upload_resume(inputs)
	return en_candidate_profile_upload_resume(inputs)
});